import { tryCatch } from '@/services/api-client';
import { dataProvider } from '@/services/data-provider';
import { GetListParams } from '../common/common.types';
import {
  Channel,
  ChannelPhoneNumber,
  CreateChannelBody,
  CreateChannelPhoneNumberBody,
} from './channels.types';
import { queryClient } from '@/lib/react-query';

export const getChannelsList = async ({
  filter,
  sort,
  order,
  perPage,
  page,
}: GetListParams) => {
  const { data: response, error } = await tryCatch(
    dataProvider.getList<Channel>('channels', {
      pagination: { page: page || 1, perPage: perPage || 10 },
      sort: { field: sort || 'updated_at', order: order || 'DESC' },
      filter,
    }),
  );

  if (error) {
    throw error;
  }

  return response;
};

export const getChannel = async ({ id }: { id: string }) => {
  console.log('calling getChannel', id);
  const { data: response, error } = await tryCatch(
    dataProvider.getOne<Channel>('channels', {
      id,
    }),
  );

  if (error) {
    throw error;
  }

  return response;
};

export async function fetchChannel({ id }: { id: string }) {
  const data = await queryClient.fetchQuery({
    queryKey: ['channel', id],
    queryFn: () => getChannel({ id }),
  });

  return data;
}

export const getChannelPhoneNumbersList = async ({
  filter,
  sort,
  order,
  perPage,
  page,
}: GetListParams) => {
  const { data: response, error } = await tryCatch(
    dataProvider.getList<ChannelPhoneNumber>('channel-phone-numbers', {
      pagination: { page: page || 1, perPage: perPage || 10 },
      sort: { field: sort || 'updated_at', order: order || 'DESC' },
      filter,
    }),
  );

  if (error) {
    throw error;
  }

  return response;
};

export const updateChannel = async ({
  id,
  data,
  previousData,
}: {
  id: string;
  data: Partial<Channel>;
  previousData: Partial<Channel>;
}) => {
  const { data: response, error } = await tryCatch(
    dataProvider.update<Channel>('channels', {
      id,
      data,
      previousData,
    }),
  );

  if (error) {
    throw error;
  }

  return response;
};

export const createChannel = async (data: CreateChannelBody) => {
  const { data: response, error } = await tryCatch(
    dataProvider.create<Channel>('channels', { data }),
  );

  if (error) {
    throw error;
  }

  return response;
};

export const createChannelPhoneNumber = async (
  data: CreateChannelPhoneNumberBody,
) => {
  const { data: response, error } = await tryCatch(
    dataProvider.create<ChannelPhoneNumber>('channel-phone-numbers', { data }),
  );

  if (error) {
    throw error;
  }

  return response;
};

export const updateChannelPhoneNumber = async ({
  id,
  data,
  previousData,
}: {
  id: string;
  data: Partial<ChannelPhoneNumber>;
  previousData: ChannelPhoneNumber;
}) => {
  const { data: response, error } = await tryCatch(
    dataProvider.update<ChannelPhoneNumber>('channel-phone-numbers', {
      id,
      data,
      previousData,
    }),
  );

  if (error) {
    throw error;
  }

  return response;
};

export const deleteChannel = async (id: string) => {
  const { data: response, error } = await tryCatch(
    dataProvider.delete<Channel>('channels', {
      id,
    }),
  );

  if (error) {
    throw error;
  }

  return response;
};
